module.exports = __webpack_public_path__ + "static/institutionLogoMarquette-798be7045f7cdad7cf7acf9b49bfbccf.png";